import type { Gemischt } from '../../platform/einstellungen';

/**
 * Stages Einstellungen in den Schlüsseln der alten Classic-App — für `conf` im Herzschlag
 * (`docs/classic-rest-api.md` §3.3). Die Konsole des Prüfungsleiters zeigt daran, wie ein Gerät
 * eingestellt ist. Alle Werte als Text, wie die alte App sie schickte.
 *
 * Nur, was Stage wirklich kennt; ein erfundener Wert wäre schlimmer als ein fehlender.
 *
 * ⚠️ **Keine Passwörter.** Die alte App schickte `password-for-settings` im Klartext mit; Stage
 * lässt es weg — der Herzschlag geht alle zehn Sekunden über die Leitung.
 */
const ZUORDNUNG = {
  sheet_half_points: 'half-points',
  sheet_show_timer: 'show-stop-watch',
  station_comments_enabled: 'enable-station-comments',
  text_comments: 'text-comments',
  sketch_comments: 'sketch-comments',
  audio_comments: 'audio-comments',
  video_comments: 'videos-comments',
  colorful_text: 'colorful',
  show_task_points: 'show-task-points',
  show_sum_points: 'show-sum-points',
  editable_task_points: 'editable-task-points',
  actors_enabled: 'enable-actors',
  landscape_mode: 'landscape-mode',
  auto_upload: 'auto-upload',
  min_brightness: 'min-brightness',
  max_brightness: 'max-brightness',
} as const satisfies Partial<Record<keyof Gemischt, string>>;

export function classicConf(g: Gemischt, angezeigt: string = 'de'): Record<string, string> {
  const conf: Record<string, string> = {};
  // Classic kennt nur de/en/fr; Stages „system“ heisst: die Sprache, die gerade zu sehen ist.
  const sprache = String(g.language.wert);
  conf.language = ['de', 'en', 'fr'].includes(sprache) ? sprache : angezeigt;
  for (const [unser, classic] of Object.entries(ZUORDNUNG)) {
    conf[classic] = String(g[unser as keyof typeof ZUORDNUNG].wert);
  }
  const kommentare = [
    g.text_comments, g.sketch_comments, g.audio_comments, g.video_comments, g.photo_comments,
  ].some((e) => e.wert === true);
  conf['enable-comments'] = String(kommentare);
  // Stage lädt die Medien einer Prüfung immer mit.
  conf['download-media'] = 'true';
  return conf;
}
